function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import Knob from './knob';
import Icon from '../icon';
import Text from '../text';
import '../../helpers/polyfills/closest';

var Progress = function Progress(_ref) {
  var children = _ref.children,
      circular = _ref.circular,
      className = _ref.className,
      id = _ref.id,
      label = _ref.label,
      _onClick = _ref.onClick,
      value = _ref.value,
      volume = _ref.volume,
      others = _objectWithoutProperties(_ref, ["children", "circular", "className", "id", "label", "onClick", "value", "volume"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      _volume = _useState2[0],
      setVolume = _useState2[1];

  var _volumeControlRef = useRef();

  var classes = "radial-progress-bar progress-".concat(value);

  var volumeControlOnStopDrag = function volumeControlOnStopDrag(value) {
    setVolume(Math.abs(Math.round(value + 'e2') + 'e-2') * 0.01);
  }; // circular progress


  if (circular) {
    return React.createElement("div", _extends({
      className: classes
    }, {
      id: id
    }, others), React.createElement(Progress.Text, {
      asTag: "span",
      className: classNames('label', {
        'has-description': Boolean(children)
      })
    }, label), children && React.createElement(Progress.Text, {
      asTag: "span",
      className: "description"
    }, children), React.createElement("div", {
      className: "pie"
    }));
  } // volume progress


  if (volume) {
    return React.createElement("div", {
      className: "is-volume-control",
      style: {
        padding: '1rem 0'
      }
    }, React.createElement("div", {
      className: "wrapper",
      ref: _volumeControlRef,
      onClick: function onClick(e) {
        if (e.target.classList.contains('knob')) return false;

        var current = _volumeControlRef.current.getBoundingClientRect();

        setVolume(Math.abs(Math.round((e.clientX - current.left) / (current.right - current.left) + 'e2') + 'e-2'));
        _onClick && _onClick(e);
      }
    }, React.createElement("progress", _extends({
      className: "progress is-info",
      value: _volume,
      step: 0.01,
      min: 0,
      max: 1
    }, others)), React.createElement(Knob, {
      pos_x: Math.max(_volume * 100, 0),
      parentRef: _volumeControlRef,
      onStop: function onStop(value) {
        return volumeControlOnStopDrag(value);
      },
      onMove: function onMove(e) {
        return _onClick(e);
      }
    })), React.createElement(Icon, {
      name: _volume * 100 > 1.5 ? 'volume-on' : 'volume-off'
    }));
  } // linear progress (default)


  classes = classNames('progress', className);
  return React.createElement("progress", _extends({
    className: classes,
    max: 100,
    value: value
  }, {
    id: id
  }, others), value, "%");
};

Progress.propTypes = {
  children: PropTypes.any,
  circular: PropTypes.bool,
  volume: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.number.isRequired,
  id: PropTypes.string,
  onClick: PropTypes.func
};
Progress.Text = Text;
export default withModifiers(Progress);